import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiTablePagination: {
      styleOverrides: {
        toolbar: {
          minHeight: '48px',
          display: 'flex',
          alignItems: 'center',
        },
        selectLabel: {
          margin: 0,
          lineHeight: 'normal',
          alignSelf: 'center',
        },
        displayedRows: {
          margin: 0,
          lineHeight: 'normal',
          alignSelf: 'center',
        },
        actions: {
          display: 'flex',
          alignItems: 'center',
        },
      },
    },
  },
});

export default theme;
